<button
  class="btn"
  [ngClass]="[color, size]"
  [style.height]="height"
  [disabled]="disabled"
  [class.loading]="loading"
  (click)="handleClick($event)"
  [style]="buttonStyle"
  [attr.type]="type"
>
  @if (loading) {
    <i class="animation-icon-loading-dot"><i></i><i></i><i></i></i>
  } @else {
    @if (iconLeft) {
      <div class="icon-box">
        @if (iconType === 'image') {
          <img class="icon" [src]="iconLeft" alt="Icon Left" />
        } @else {
          <i class="icon" [class]="iconLeft"></i>
        }
      </div>
    }

    @if (label) {
      <p class="label">{{ label }}</p>
    }

    @if (iconRight) {
      <div class="icon-box">
        @if (iconType === 'image') {
          <img class="icon right" [src]="iconRight" alt="Icon Right" />
        } @else {
          <i class="icon right" [class]="iconRight"></i>
        }
      </div>
    }

    <ng-content></ng-content>
  }
</button>
